/**
 * Date-related utility functions for security dashboard charts.
 */

export interface DayLabel {
  day: number;
  month: string;
}

/**
 * Generate day labels for chart x-axis based on date range.
 * @param days - Number of days (7, 30, or 90)
 * @param startMonth - Starting month name (e.g., "October")
 * @returns Array of day labels with day number and month abbreviation
 */
export function getDayLabelsForRange(days: number, startMonth: string = "October"): DayLabel[] {
  const labels: DayLabel[] = [];
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const monthIndex = monthNames.indexOf(startMonth.slice(0, 3));

  if (days === 7) {
    for (let i = 1; i <= 7; i++) {
      labels.push({ day: i, month: monthNames[monthIndex] });
    }
  } else if (days === 30) {
    [1, 5, 10, 15, 20, 25, 30].forEach((day) => {
      labels.push({ day, month: monthNames[monthIndex] });
    });
  } else if (days === 90) {
    labels.push({ day: 1, month: monthNames[monthIndex] });
    labels.push({ day: 15, month: monthNames[monthIndex] });
    labels.push({ day: 30, month: monthNames[monthIndex] });
    labels.push({ day: 14, month: monthNames[(monthIndex + 1) % 12] });
    labels.push({ day: 28, month: monthNames[(monthIndex + 1) % 12] });
    labels.push({ day: 15, month: monthNames[(monthIndex + 2) % 12] });
    labels.push({ day: 30, month: monthNames[(monthIndex + 2) % 12] });
  }
  return labels;
}
